import React, { Fragment } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import { AnchorLink } from 'react-anchor-navigation';
import { GetDays, GetNamePartner, GetTypeDays } from './functions';
import { Props } from './interfaces';
import './CalculatorTable.scss';
import './CalculatorTable-media.scss';
import Button from '../Button/Button';
import { EnumUrlsPages } from '../../services/Enum';
import {textPriceInRubles} from "../../services/content/functions";
import {content} from "../../services/content";

const CalculatorTable = ({ calculator, valueFrom, valueIn, widthWindow }: Props) => {
  const { KurDalli, KurSdek, PvzBoxberry, PvzSdek, Pvz5post, RuPost } = calculator;

  const dataTable = [
    { title: content.calculatorTable.byCourier, days: GetDays([KurDalli, KurSdek]), list: [KurDalli, KurSdek] },
    { title: content.calculatorTable.byPvz, days: GetDays([PvzBoxberry, PvzSdek, Pvz5post]), list: [PvzBoxberry, PvzSdek, Pvz5post] },
    { title: content.calculatorTable.byPost, days: GetDays([RuPost]), list: [RuPost] },
  ];

  return (
    <div className="price-block">
      <div className="price-block__print-info">
        <div className="price-block__bg2"></div>
        <h2 className="price-block__title">{content.calculatorTable.title}</h2>
        <div className="price-block__cities">
          <div className="price-block__city">
            <h4>{valueFrom}</h4>
          </div>
          <div className="price-block__arrow"></div>
          <div className="price-block__city">
            <h4>{valueIn}</h4>
          </div>
        </div>
        <div className="price-block__table">
          {dataTable.map(({ title, days, list }, i) =>
            !(days === '-1') ? (
              <Fragment key={i}>
                <h3 className="price-block__grid-partner">{title}</h3>
                {list.map(({ price, partner, errormsg }, idx) =>
                  errormsg ? null : (
                    <div className="price-block__grid-line" key={idx}>
                      {price.map(({ price, delivery_period }, index) => (
                        <Fragment key={index}>
                          {GetNamePartner(partner)}
                          <h4>{textPriceInRubles(price)}</h4>
                          <h4>{`${delivery_period} ${GetTypeDays(delivery_period)}`}</h4>
                        </Fragment>
                      ))}
                    </div>
                  )
                )}
              </Fragment>
            ) : null
          )}
        </div>
      </div>
      <p className="body2 price-block__text-bottom">
        {content.calculatorTable.text}
      </p>
      <AnchorLink href="#form" activeClassName="selected">
        <Button text={content.calculatorTable.button} widthAll={widthWindow < 720} />
      </AnchorLink>
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(CalculatorTable));
